<template>
	<el-dialog :visible="show" append-to-body algin="center" z-index="9999" :title="dialogTitle" width="750px" @close="$emit('update:show', false)">
		<div v-loading="loadingComment" class="comment-info">
			<template v-if="commentData">
				<div class="header v-mb-10">
					<div class="v-mr-20 v-font-16 v-color-blue v-font-bold">{{ commentData.nickname }}</div>
					<div class="time v-font-12 v-color-gray">{{ commentData.create_time }}</div>
					<div v-if="commentData.to_user_info" class="v-mr-20 v-font-12">处理人：{{commentData.to_user_info.nickname}}（{{commentData.to_user_info.login_name}}）</div>
					<div v-if="!isNaN(status)" class="v-font-12" :style="{color:polylineInfo[status].color}">{{polylineInfo[status].text}}</div>
				</div>
				<div class="content">
					<div class="comment v-font-18">{{ commentData.content }}</div>
					<div class="comment-operator">
						<!--  未指派  -->
						<comment-assign-user v-if="isShouldSelectUser" :worksId="worksId" :id="pointsId" @success="getComment" @update="updatePolyline($event)"/>
						<!--  发起人-拒绝通过  ---  处理人-完成任务   -->
						<el-button v-if="status == 2 && commentData.is_owner" class="v-ml-10" type="danger" size="small" :loading="doSubmitLoading" @click="doSubmit(1)">拒绝通过</el-button>
						<!--  发起人-确认通过  ---   处理人-处理中/完成任务  -->
						<el-button v-if="(status == 1 || status == 2)  && commentData.is_owner" type="success" size="small" :loading="doSubmitLoading" @click="doSubmit(3)">确认通过</el-button>
						<!--  处理人-完成任务  -->
						<el-button v-if="status == 1 && commentData.is_director" type="success" size="small" :loading="doSubmitLoading" @click="doSubmit(2)">完成任务</el-button>

						<el-button v-if="view" class="view v-ml-20" type="primary" size="small" @click="toView">查看问题</el-button>
					</div>
				</div>
			</template>
		</div>
		<!--  问题回复列表  -->
		<comment-reply :commentId="comment_id" :worksId="worksId" :materialId="materialId"/>

	</el-dialog>
</template>

<script>
	import polylineInfo from '../polyline'
	import commentAssignUser from './comment-assign-user'
	import commentReply from './comment-reply'
	export default {
		components:{commentAssignUser,commentReply},

		props:{
			show:Boolean,
			comment_id:String,
			view:Boolean,
		},

		data() {
			return {
				krp: this.$store.getters.krpDom,
				userInfo: this.$store.getters.userInfo,
				polylineInfo,
				loadingComment: false,
				commentData: null,
				doSubmitLoading: false,
			};
		},

		computed: {
			dialogTitle() {
				return this.commentData ? `${this.commentData.points_title}_${this.commentData.points_id}` : '问题详情'
			},
			isShouldSelectUser(){ // 是否需要选取指派人
				return this.userInfo.level != 3 && this.commentData && this.commentData.points_status == 0
			},
			worksId(){
				return this.commentData ? this.commentData.works_id : 0
			},
			materialId(){
				return this.commentData ? this.commentData.material_id : 0
			},
			pointsId(){
				return this.commentData ? this.commentData.points_id : 0
			},
			status(){
				return this.commentData ? this.commentData.points_status : 0
			}
		},

		created() {
			this.getComment();
		},

		methods: {

			//获取评论内容
			async getComment() {
				this.loadingComment = true;
				try {
					let res = await this.api.comment.getReplyRow({id: this.comment_id});
					this.commentData = res.data;
				} catch (e) {
					console.error(e);
				}
				this.loadingComment = false;
			},

			//查看折线
			toView() {
				let c = this.commentData;
				let ath = 0;
				let atv = 0;
				if (c.mode == 1) {
					ath = Number(c.points[0].ath) + Number(c.points[1].ath - c.points[0].ath) / 2;
					atv = Number(c.points[0].atv) + Number(c.points[3].atv - c.points[0].atv) / 2;
				} else {
					ath = Number(c.points[c.points.length - 1].ath);
					atv = Number(c.points[c.points.length - 1].atv);
				}
				let routeResolve = this.$router.resolve({ path: '/preview',
					query: {
						id: c.works_id,
						material_id:c.material_id,
						ath,
						atv
				}
				});
				window.open(routeResolve.href,'_blank');
			},

			//任务状态流转
			async doSubmit(status) {
				this.doSubmitLoading = true;
				try {
					await this.api.polyline.roam({id: this.pointsId, status});
					this.krp && this.krp.call(`set(hotspot[${this.commentData.name}].bordercolor,${polylineInfo[status].color16})`);
					this.$message.success('操作成功');
					this.getComment();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			},

			updatePolyline(status){
				this.krp && this.krp.call(`set(hotspot[${this.commentData.name}].bordercolor,${polylineInfo[status].color16})`);
			}


		},
	};
</script>

<style scoped>
	/deep/ .el-dialog__header{
		text-align:center;
	}
	.comment-info {
		padding-bottom: 15px;
		margin-bottom: 15px;
		border-bottom: 1px solid #eee;
		min-height: 68px;
	}

	.comment-info .header {
		display: flex;
		align-items: center;
		height: 20px;
	}

	.comment-info .header .time {
		flex: 1;
	}

	.comment-info .content{
		display: flex;
		align-items: center;
	}
	.comment-info .content .comment{
		flex:1;
	}

</style>
